/* yb-upcart-style.js — Brandea el cajon de UpCart como yoracare + bloque de confianza al pie.
 *
 * Hace:
 *  1) COLORES: header + boton de checkout en verde de marca #2d5a3d; barra de progreso de
 *     envio gratis en el verde VIVO de yoracare #007E40 (su segment-fill real).
 *  2) HEADER CENTRADO: el titulo ("Yurabel") va centrado como "Yoracare"; la X queda a la derecha.
 *  3) BLOQUE DE CONFIANZA al pie (debajo del boton de checkout): titulo "COMPRA 100% SEGURA",
 *     la tira de iconos de pago (payment-icons.webp de UpCart) y un "Why Choose Us" de 3 columnas
 *     (Calidad garantizada / Compra segura / Devolucion 30 dias). Esto replica el bloque de
 *     seguridad de curvy-faja PERO en el cajon (el checkout de Shopify no lo permite sin Plus).
 *
 * Como: UpCart se renderiza en Shadow DOM y colorea via variables CSS. Inyectamos un <style> y el
 * bloque de confianza en su shadow root. Se re-aplica en cada render del cajon (hooks
 * upcartSubscribeCart*) por si UpCart lo recrea. Idempotente.
 *
 * Reversible: borrar este asset + su <script> de layout/theme.liquid.
 */
/* rev: 2026-06-16-4 (+ bloque de confianza: Compra 100% Segura + Why Choose Us) */
(function () {
  'use strict';

  var GREEN = '#2d5a3d';       // verde de marca (header + boton checkout + iconos confianza)
  var PROGRESS = '#007E40';    // verde VIVO de la barra de progreso (exacto de yoracare)
  var STYLE_ID = 'yb-upcart-green';
  var TRUST_ID = 'yb-trust';
  var PAY_ID = 'yb-pay-icons';
  var PAY_SRC = 'https://storage.googleapis.com/upcart-public/payment-icons.webp';

  // SVGs (stroke = currentColor, heredan el verde)
  var SVG = {
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>',
    rotate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>'
  };

  var CSS = [
    /* variables globales del cajon */
    '*{',
    '  --upcart-internal-component-progress-bar-foreground-color:' + PROGRESS + ' !important;',
    '  --upcart-internal-global-button-background-color:' + GREEN + ' !important;',
    '  --upcart-internal-header-close-button-icon-color:#ffffff !important;',
    '  --upcart-internal-header-close-button-icon-color-hover:#ffffff !important;',
    '}',
    /* respaldo directo: el segmento "lleno" de la barra de progreso (verde vivo) */
    '[class*="progress-bar__segment-fill" i]{background-color:' + PROGRESS + ' !important;}',
    /* boton de checkout (clase estable upcart-checkout-button) en verde de marca */
    '.upcart-checkout-button{background-color:' + GREEN + ' !important;}',
    /* CABECERA verde con texto/icono en blanco (branding como yoracare) */
    '.upcart-internal-header,.upcart-public-header{background-color:' + GREEN + ' !important;position:relative !important;justify-content:center !important;}',
    /* titulo CENTRADO (como "Yoracare") */
    '.upcart-internal-header h4,.upcart-public-header h4{color:#ffffff !important;text-align:center !important;width:100% !important;margin:0 !important;}',
    /* X reposicionada a la derecha, superpuesta */
    '.upcart-internal-header__close-button{color:#ffffff !important;position:absolute !important;right:20px !important;top:50% !important;transform:translateY(-50%) !important;}',
    '.upcart-internal-header__close-button svg,.upcart-internal-header__close-button svg *{stroke:#ffffff !important;fill:#ffffff !important;}',
    /* ---- BLOQUE DE CONFIANZA ---- */
    '#' + TRUST_ID + '{margin:12px auto 4px !important;padding:12px 8px 4px !important;border-top:1px solid #ececec !important;text-align:center !important;}',
    '#' + TRUST_ID + ' .yb-trust-head{display:flex !important;align-items:center !important;justify-content:center !important;gap:6px !important;color:' + GREEN + ' !important;font-size:12px !important;font-weight:700 !important;letter-spacing:.04em !important;text-transform:uppercase !important;margin:0 0 8px !important;}',
    '#' + TRUST_ID + ' .yb-trust-head svg{width:15px !important;height:15px !important;flex:0 0 auto !important;}',
    '#' + PAY_ID + '{display:block !important;width:100% !important;max-width:280px !important;height:auto !important;margin:0 auto 10px !important;}',
    '#' + TRUST_ID + ' .yb-trust-why{display:flex !important;justify-content:space-around !important;align-items:flex-start !important;gap:6px !important;}',
    '#' + TRUST_ID + ' .yb-why{flex:1 1 0 !important;display:flex !important;flex-direction:column !important;align-items:center !important;gap:5px !important;color:#444 !important;font-size:11px !important;line-height:1.25 !important;}',
    '#' + TRUST_ID + ' .yb-why svg{width:24px !important;height:24px !important;color:' + GREEN + ' !important;}'
  ].join('');

  function getRoot() {
    try { if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot; } catch (e) {}
    var host = document.querySelector('[id*="upcart" i],[class*="upcart" i]');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function injectStyle(root) {
    if (!root) return false;
    try {
      if (root.querySelector && root.querySelector('#' + STYLE_ID)) return true; // ya inyectado
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = CSS;
      root.appendChild(s);
      return true;
    } catch (e) { return false; }
  }

  /* Bloque de confianza debajo del boton de checkout (titulo + tarjetas + Why Choose Us). */
  function injectTrustBlock(root) {
    if (!root) return;
    try {
      if (root.querySelector('#' + TRUST_ID)) return; // ya esta
      var co = root.querySelector('.upcart-checkout-button');
      if (!co) return;
      // pie EXTERNO del cajon (orden normal). OJO: el wrapper interno del boton es column-reverse,
      // por eso hay que anexar al .upcart-footer externo para que quede DEBAJO del boton.
      var footer = co.closest('.upcart-footer') || co.closest('[class*="upcart-footer" i]') || co.closest('[class*="Footer__" i]') || co.parentElement;
      if (!footer) return;
      var box = document.createElement('div');
      box.id = TRUST_ID;
      box.innerHTML =
        '<div class="yb-trust-head">' + SVG.lock + 'Compra 100% Segura</div>' +
        '<img id="' + PAY_ID + '" src="' + PAY_SRC + '" alt="Metodos de pago" loading="lazy">' +
        '<div class="yb-trust-why">' +
          '<div class="yb-why">' + SVG.shield + '<span>Calidad<br>garantizada</span></div>' +
          '<div class="yb-why">' + SVG.lock + '<span>Compra<br>segura</span></div>' +
          '<div class="yb-why">' + SVG.rotate + '<span>Devolución<br>30 días</span></div>' +
        '</div>';
      footer.appendChild(box); // ultimo hijo del pie -> DEBAJO del boton
    } catch (e) {}
  }

  function applyAll() {
    var root = getRoot();
    injectStyle(root);
    injectTrustBlock(root);
  }

  function boot() {
    applyAll();
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      try { if (typeof window[fn] === 'function') window[fn](function () { setTimeout(applyAll, 20); }); } catch (e) {}
    });
    var n = 0;
    var iv = setInterval(function () { n++; applyAll(); if (n > 30) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
